import React, {useMemo} from 'react';
import {useParams} from 'react-router-dom';

import {getLink} from '@appComponents/Link';
import {routes} from '@constants/routes';
import EventContentWatermarkingForm from '@modules/events/forms/EventContentWatermarking/EventContentWatermarkingForm';
import EventContentWatermarkingModel from '@modules/events/forms/EventContentWatermarking/EventContentWatermarkingModel';
import EventWatermarkingEditFormLoader from '@modules/events/components/EventWatermarking/EventWatermarkingEditFormLoader';
import {createForm} from '@utils/forms';
import {convertToInt} from '@utils/helpers';
import {useModalRouting} from '@utils/hooks/useModalRouting';

const EventWatermarkingModalRouting = () => {
    const {id: eventId, eventContentWatermarkId} = useParams();
    const watermarkingIndexUrl = getLink('events.watermarking.index', {id: eventId});

    const routesMap = useMemo(() => {
        const Form = createForm(
            EventContentWatermarkingModel,
            EventContentWatermarkingForm,
            {
                dataRequest: false,
                optionsFetchPolicy: 'no-cache',
                optionsVariables: {
                    event: convertToInt(eventId),
                },
            }
        );

        return [
            {
                path: routes.events.watermarking.add.path,
                header: false,
                render: () => <Form />,
                size: 'small',
            },
            {
                path: routes.events.watermarking.edit.path,
                header: false,
                render: () => (
                    <EventWatermarkingEditFormLoader
                        eventContentWatermarkId={eventContentWatermarkId}
                        eventId={eventId}
                    />
                ),
                size: 'small',
            },
        ];
    }, [eventContentWatermarkId, eventId]);

    useModalRouting({
        routesMap,
        indexUrl: watermarkingIndexUrl,
    });

    return null;
};

EventWatermarkingModalRouting.displayName = 'EventWatermarkingModalRouting';

export default EventWatermarkingModalRouting;
